module.exports = __webpack_public_path__ + "img/hero-mobile-upper.a227b502.png";